<template>
  
  <v-app v-scroll="onScroll">
    <div
    id="layout-loader" 
    v-show="showLoader"
    style=" position: absolute;
    z-index: 9999;
    background: white;
    height: 100vh;
    width: 100%;">
    <v-flex
      justify-center
      fill-height
      align-center
      class="d-flex default-loader"
    >
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
        justify-center
        align-center
      />
    </v-flex>
    </div>

    <main-navbar :path="$nuxt.$route.path" style="position: absolute;"/>
    <v-main class="pb-0 fill-height pt-0" style="position: relative;">
      <slot>
        <!-- Fallback content for pages directly using the default layout -->
        <nuxt />
      </slot>
    </v-main>
  </v-app>
</template>

<script>
import MainNavbar from '~/components/MainNavbar.vue';
export default {
  head() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true });
    return {
      title: 'Storytelling & Coding for Kids',
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no' },
        { hid: 'description', name: 'description', content: 'Elementari is an online platform to write, code, and share interactive stories using professional illustrations and sounds. Get started for free.' },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: 'Elementari' },
        { hid: 'og:title', property: 'og:title', content: 'Coding for Kids with Arts and Literacy' },
        { hid: 'og:description', property: 'og:description', content: 'Elementari is the easiest way for kids to learn coding by creating projects across the curriculum. Fun, interactive lessons to code stories, games, and more!' },
        { hid: 'og:image', property: 'og:image', content: 'https://elementari.com/img/website/og_en.png' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@elementari' },
        { property: 'fb:app_id', content: '1018702751550379' },
        ...i18nHead.meta
      ],
      link: [
        { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' },
        { rel: 'apple-touch-icon', href: '/favicon/app-icon-152.png' },
        { rel: 'apple-touch-icon', sizes: '152x152', href: '/favicon/app-icon-152.png' },
        { rel: 'apple-touch-icon', sizes: '167x167', href: '/favicon/app-icon-167.png' },
        { rel: 'apple-touch-icon', sizes: '180x180', href: '/favicon/app-icon-180.png' },
        { rel: 'manifest', href: '/manifest.json' },
        ...i18nHead.link
      ],
      script: [
      {
        type: 'text/javascript',
        innerHTML: `
          (function() {
            // Immediately check for the auth cookie.
            const loginCookie = document.cookie.match(/(?:^|; )auth\\._token\\.local=([^;]*)/);
            // Loader should be shown only if cookie exists and its value is 'true'
            const showLoader = loginCookie && loginCookie[1] !== 'false';
            window.__initialShowLoader = showLoader;
            // If not, add a global class that hides the loader
            if (!showLoader) {
              document.documentElement.classList.add('no-loader');
            }
          })();
        `,
      }
    ],
      __dangerouslyDisableSanitizers: ['script'], 
    };
  },
  scrollToTop: true,
  components: {
    MainNavbar
    // 'main-navbar': () =>
    //     import('~/components/MainNavbar.vue'),
  },
  data() {
    return {
      offsetTop: 0,
      goToTopHidden: true,
      drawer: null,
      greyBgPages: ['/', 'studio'],
      transparentPages: [
        'features',
        'about',
        'educators',
        'artists',
        'researchers',
        'about',
        'hourofcode',
        'grants',
        'quote',
        'stories',
        'lessons',
        'index'
      ],
      showLoader: typeof window !== 'undefined' && window.__initialShowLoader !== undefined
        ? window.__initialShowLoader
        : true,
    };
  },

  computed: {
    redirectClassroomSelect() {
      if (!this.$auth.loggedIn || !this.$auth.user.is_student) {
        return { loading: false };
      }
      if (this.$auth.user.is_student) {
        if (this.$auth.user.student_data.need_pass_change) {
          return { loading: true, path: '/account/password-change/' };
        }  else {
          return { loading: true, path: '/' };
        }
      }
      return { loading: false };
    }
  },
  watch: {
    redirectClassroomSelect(newVal) {
      if (newVal.path) {
        this.$router.push(this.localePath(newVal.path));
        this.redirectClassroomSelect.loading = false;
      }
    }
  },
  created() {
    if (!this.$auth.loggedIn || !this.$auth.user.is_student || this.$auth.user.student_data.need_pass_change) return;
  },
  mounted() {
    if (this.$auth.loggedIn){
        this.showLoader = false
      }
  },
  methods: {

    // isNavbarElevated() {
    //   return false
    //   if (this.$route.name == 'index' && this.$auth.loggedIn) return false;
    //   if (this.transparentPages.includes(this.$route.name)) return true;
    //   return false;
    // },
    onScroll() {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.offsetTop > 300) {
        this.goToTopHidden = false;
      } else {
        this.goToTopHidden = true;
      }
    }
  }
};
</script>

<style scoped>
.v-application {
  background-color: #f8f8f8 !important;
}
</style>

<style>
.default-loader {
  z-index: 301;
  position: absolute;
  width: 100%;
  display: flex;
  height: 100vh;
  background-color: white;
}
body {
  touch-action: manipulation;
}
@media screen and (max-width: 600px) {
  .mobileNoPadding {
    padding: 0;
  }
}

.title-divider {
  background: linear-gradient(133deg, #00c4cc 10%, #7d2ae8 90%);
  display: inline-block;
  width: 30%;
  height: 3px;
}
#layout-loader {
  transition: opacity 0.3s ease, visibility 0s 0.3s;
}

#layout-loader.hidden {
  opacity: 0;
  visibility: hidden;
}

.loader {
  transition: opacity 0.3s ease-out;
}
.no-loader #layout-loader {
  display: none !important;
}
</style>